import { useEffect } from 'react';

import { checkPasswordStrength } from '../stytchHelpers';
import type { CheckPasswordResponse } from '../types/Auth';

const DEBOUNCE_DELAY_MS = 250;

interface StrengthDebounceProps {
    delay?: number;
    onChange: (response: CheckPasswordResponse) => void;
    watchedPassword: string;
}

export const useDebouncedPasswordCheck = (props: StrengthDebounceProps) => {
    const { watchedPassword, delay = DEBOUNCE_DELAY_MS, onChange } = props;

    useEffect(() => {
        const checkStrength = async () => {
            const response = await checkPasswordStrength(watchedPassword);
            onChange(response);
        };

        const debounceTimer = setTimeout(() => {
            if (watchedPassword) {
                void checkStrength();
            }
        }, delay);

        return () => {
            clearTimeout(debounceTimer);
        };
    }, [watchedPassword, delay, onChange]);
};
